function initProductPage() {
  const productPage = document.querySelector('.product-page');
  if (productPage === null) {
    return;
  }
  initProductPageMedia();
  initProductPriceButtons();
  initProductPageAddToCartForm();
  initProductPageDescriptionToggle();
  initProductPagePropertiesToggle();
}


function initProductPageMedia() {
  const items = document.querySelectorAll('.product-page__media-item-media');
  if (items.length < 2) {
    return;
  }
  const buttons = document.querySelectorAll('.product-page__media-button');
  const previousButton = document.querySelector('.product-page__media-item-button--left');
  const nextButton = document.querySelector('.product-page__media-item-button--right');
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      items.forEach((item) => {
        if (item.dataset.mediaId === button.dataset.mediaId) {
          item.classList.add('product-page__media-item-media--active');
        } else {
          item.classList.remove('product-page__media-item-media--active');
        }
      });
      buttons.forEach((otherButton) => {
        if (otherButton.dataset.mediaId === button.dataset.mediaId) {
          otherButton.classList.add('product-page__media-button--active');
        } else {
          otherButton.classList.remove('product-page__media-button--active');
        }
      });
    });
  });
  previousButton.addEventListener('click', () => {
    const currentActiveButton = document.querySelector('.product-page__media-button--active');
    let newActiveButton = currentActiveButton.previousElementSibling;
    if (newActiveButton === null) {
      newActiveButton = document.querySelector('.product-page__media-button:last-child');
    }
    newActiveButton.click();
  });
  nextButton.addEventListener('click', () => {
    const currentActiveButton = document.querySelector('.product-page__media-button--active');
    let newActiveButton = currentActiveButton.nextElementSibling;
    if (newActiveButton === null) {
      newActiveButton = document.querySelector('.product-page__media-button:first-child');
    }
    newActiveButton.click();
  });
}


function initProductPriceButtons() {
  const priceElements = document.querySelectorAll('.product-page__price-value');
  const pickupPriceButton = document.getElementById('product-page-pickup-price-button');
  const shippingPriceButton = document.getElementById('product-page-shipping-price-button');
  if (pickupPriceButton === null || shippingPriceButton === null) {
    return;
  }
  pickupPriceButton.addEventListener('click', () => {
    pickupPriceButton.classList.add('product-page__price-button--active');
    shippingPriceButton.classList.remove('product-page__price-button--active');
    priceElements.forEach((priceElement) => {
      priceElement.innerText = priceElement.dataset.pickupPrice;
    });
    localStorage.setItem('priceType', 'pickup');
  });
  shippingPriceButton.addEventListener('click', () => {
    pickupPriceButton.classList.remove('product-page__price-button--active');
    shippingPriceButton.classList.add('product-page__price-button--active');
    priceElements.forEach((priceElement) => {
      priceElement.innerText = priceElement.dataset.shippingPrice;
    });
    localStorage.setItem('priceType', 'shipping');
  });
}


function initProductPageAddToCartForm() {
  const productPageCart = document.querySelector('.product-page__cart');
  if (productPageCart.classList.contains('product-page__cart--disabled')) {
    return;
  }
  const toggleUp = document.querySelector('.product-page__cart-quantity-button--plus');
  const toggleDown = document.querySelector('.product-page__cart-quantity-button--minus');
  const input = document.querySelector('.product-page__cart-quantity-input');
  const addToCartButton = document.querySelector('.product-page__cart-add-button');

  toggleUp.addEventListener('click', (event) => {
    const value = parseInt(input.value);
    let newValue = null;
    if (isNaN(value) || value < 1) {
      newValue = 1;
    } else {
      newValue = value + 1;
    }
    if (newValue !== value) {
      input.value = newValue;
      toggleDown.classList.remove('product-page__cart-quantity-button--disabled');
    }
  });

  toggleDown.addEventListener('click', (event) => {
    const value = parseInt(input.value);
    let newValue = null;
    if (isNaN(value) || value < 2) {
      newValue = 1;
    } else {
      newValue = value - 1;
    }
    if (newValue !== value) {
      input.value = newValue;
      if (newValue === 1) {
        toggleDown.classList.add('product-page__cart-quantity-button--disabled');
      }
    }
  });

  input.addEventListener('change', (event) => {
    let value = parseInt(event.target.value);
    if (isNaN(value) || value < 1) {
      value = 1;
      input.value = value;
    }
    if (value === 1) {
      toggleDown.classList.add('product-page__cart-quantity-button--disabled');
    } else {
      toggleDown.classList.remove('product-page__cart-quantity-button--disabled');
    }
  });


  addToCartButton.addEventListener('click', async (event) => {
    let value = parseInt(input.value);
    if (isNaN(value) || value < 1) {
      value = 1;
    }
    addToCartButton.classList.add('product-page__cart-add-button--loading');
    await Layout.addToCart(parseInt(input.value), addToCartButton.dataset.productId);
    addToCartButton.classList.remove('product-page__cart-add-button--loading');
  });

}


function initProductPagePropertiesToggle() {
  const showMoreButton = document.querySelector('.product-page__properties-show-more-button');
  const showLessButton = document.querySelector('.product-page__properties-show-less-button');
  if (showMoreButton === null || showLessButton === null) {
    return;
  }

  showMoreButton.addEventListener('click', (event) => {
    const table = document.querySelector('.product-page__properties-table');
    const hiddenRows = document.querySelectorAll('.product-page__properties-table-row--hidden');
    hiddenRows.forEach((hiddenRow) => {
      hiddenRow.classList.remove('product-page__properties-table-row--hidden');
    });
    showMoreButton.classList.add('product-page__properties-show-more-button--hidden');
    showLessButton.classList.remove('product-page__properties-show-less-button--hidden');
  });

  showLessButton.addEventListener('click', (event) => {
    const table = document.querySelector('.product-page__properties-table');
    const rows = document.querySelectorAll('.product-page__properties-table-row');
    rows.forEach((row, index) => {
      if (index < 10) {
        return;
      }
      row.classList.add('product-page__properties-table-row--hidden');
    });
    showMoreButton.classList.remove('product-page__properties-show-more-button--hidden');
    showLessButton.classList.add('product-page__properties-show-less-button--hidden');
  });
}


function initProductPageDescriptionToggle() {
  const description = document.querySelector('.product-page__description');
  if (description === null) {
    return;
  }
  const descriptionContent = description.querySelector('.product-page__description-content');
  if (descriptionContent.clientHeight <= 144) {
    description.classList.add('product-page__description--no-toggle');
    return;
  }
  const descriptionToggleShowMorebutton = description.querySelector('.product-page__description-toggle-show-more-button');
  descriptionToggleShowMorebutton.addEventListener('click', (event) => {
    if (description.classList.contains('product-page__description--animating')) {
      return;
    }
    description.classList.add('product-page__description--animating');
    description.classList.add('product-page__description--open');
    description.style.height = (descriptionContent.clientHeight + 19) + 'px';
    description.style.paddingBottom = '19px';
    setTimeout(() => {
      description.style.height = 'auto';
      description.classList.remove('product-page__description--animating');
    }, 400);
  });
  const descriptionToggleShowLessbutton = description.querySelector('.product-page__description-toggle-show-less-button');
  descriptionToggleShowLessbutton.addEventListener('click', (event) => {
    if (description.classList.contains('product-page__description--animating')) {
      return;
    }
    description.classList.add('product-page__description--animating');
    description.classList.remove('product-page__description--open');
    description.style.height = (description.clientHeight) + 'px';

    setTimeout(() => {
      description.style.height = '144px';
      description.style.paddingBottom = '0';
      setTimeout(() => {
        description.classList.remove('product-page__description--animating');
      }, 400);
    }, 0);
  });
}


if (document.readyState !== 'loading') {
  initProductPage();
} else {
  window.addEventListener('DOMContentLoaded', initProductPage);
}
